import React, { useState } from "react";
import Swal from "sweetalert2";
import LicenciaSelect from "./LicenciaSelect";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import axios from 'axios';

const CarpetaForm = ({ cadete, onClose }) => {
  const [formData, setFormData] = useState('');
  const [valor, setValor] = useState('');
  const Usuario = ObtieneDatosCookies()
  
  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Solo permitimos letras (de la A a la Z, mayúsculas o minúsculas)
    if (/^[A-Za-z]*$/.test(inputValue)) {
      setValor(inputValue);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Validar solo letras para el campo cadeteDomicilio
    if (name === "cadeteDomicilio" && !/^[A-Za-z\s]*$/.test(value)) {
      return; // Si no cumple con el patrón, no actualizamos el estado
    }

    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const today = new Date();
const generaNuevoReconocimiento=async()=>{
 
const reconocimientoMedico={
  cadeteDni :cadete.cadeteDni,
  cadeteSede:cadete.cadeteSede,
  promocionId:cadete.Promocions[0].id,
  fechaSolicitud:today,
  usuarioRecepciono:Usuario.apellido+", "+Usuario.nombre + "("+Usuario.dependenciaNombre+")",
  motivoSolicitud:formData.motivoSolicitud,
}

try {

    const username = process.env.REACT_APP_KEY; 
    const password = process.env.REACT_APP_PASS; 
    const token = btoa(`${username}:${password}`);
// console.log(cadete)
    const response = await axios.post(
      `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/creaCarpetaMedica/`,
      reconocimientoMedico,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    if(response){
     if(response.data.success){
      Swal.fire({
        title: "Reconocimiento medico Generado Exitosamente!!",
        text: response.data.message,
        icon: "success",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
        }
      });
     }else{
//       console.log(response.data)
      Swal.fire({
        title: "No se pudo generar la carpeta medica",
        text: response.data.message,
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
      })
     }
      
    
  }}catch(error){
//     console.log(error)
    Swal.fire({
      title: "Aun tiene una carpeta medica sin diagnosticar",
      text: "Tenga en cuenta que el cadete cuenta con una carpeta medica sin diagnosticar",
      icon: "error",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        onClose();
      }
    });
  }




}

  const handleReempadronar = () => {
    const { motivoSolicitud } = formData;
    const formControls = document.querySelectorAll(".form-control");
    const hasInvalidFields = Array.from(formControls).some((input) =>
      input.classList.contains("is-invalid")
    );

    if (hasInvalidFields) {
      Swal.fire({
        title: "Error",
        text: "Por favor, corrige los campos en rojo.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }
    if (!motivoSolicitud) {
      Swal.fire({
        title: "Error",
        text: "Por favor, completa todos los campos requeridos.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    Swal.fire({
      title: "¿Estás seguro?",
      text: "Vas a Generar un nuevo Reconocimiento Medico para el cadete.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, generar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
       generaNuevoReconocimiento()
        
      }
    });
  };

  const handleCancel = () => {

    onClose();


  };


  
 

  // Calcular la fecha mínima: 18 años atrás
  const minDate = new Date(today);
  minDate.setFullYear(today.getFullYear() - 18);

  // Formatear la fecha a 'YYYY-MM-DD' para el valor del input
  const minDateString = minDate.toISOString().split('T')[0];
  return (
    <div style={{ maxHeight: "550px", maxWidth: "650px", overflow: "auto", margin: "0 auto", }}
    >

      <div>


        <div className="d-flex justify-content-center gap-3 mb-3">
          <img
            src={`https://wwwa.isepsantafe.net.ar/imagenes/${cadete.fotoCadete}`}
            alt="Foto Cadete"
            className="rounded-circle border"
            style={{ height: "120px", width: "120px", cursor: "pointer" }}

          />

        </div>
      </div>
      <form style={{ textAlign: "center" }}>
        <h5>{cadete.Seccion.nombre + " de la " + cadete.Seccion.Compania.nombre}</h5>
        <div >

          <div className="">
            <label>Motivo de la Solicitud</label>
            <textarea
              name="motivoSolicitud"
              value={formData.motivoSolicitud || ""}
              onChange={handleInputChange}
              required
              minLength={12}
              className={`form-control ${!formData.motivoSolicitud || formData.motivoSolicitud.length < 12 ? "is-invalid" : "is-valid"}`}
              rows="4" // Ajusta la cantidad de filas visibles
            />
          </div>




        </div>

        <div className="">
          <button
            type="button"
            className="btn btn-primary me-2"
            onClick={handleReempadronar}
          >
            Crear Reconocimiento
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleCancel}
          >
            Cancelar
          </button>
        </div>
      </form>

    </div>
  );
};

export default CarpetaForm;
